import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2H18C19.0609 2 20.0783 2.42143 20.8284 3.17157C21.5786 3.92172 22 4.93913 22 6V14C22 15.0609 21.5786 16.0783 20.8284 16.8284C20.0783 17.5786 19.0609 18 18 18H8C7.60322 17.9924 7.20889 18.0637 6.83983 18.2096C6.47078 18.3555 6.13434 18.5732 5.85 18.85L2.85 21.85C2.80462 21.8971 2.75028 21.9346 2.69017 21.9604C2.63006 21.9862 2.5654 21.9996 2.5 22C2.36739 22 2.24021 21.9473 2.14645 21.8536C2.05268 21.7598 2 21.6326 2 21.5V6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2ZM12.8536 13.8536C12.9473 13.7598 13 13.6326 13 13.5V12.5C13 12.3674 12.9473 12.2402 12.8536 12.1464C12.7598 12.0527 12.6326 12 12.5 12H11.5C11.3674 12 11.2402 12.0527 11.1464 12.1464C11.0527 12.2402 11 12.3674 11 12.5V13.5C11 13.6326 11.0527 13.7598 11.1464 13.8536C11.2402 13.9473 11.3674 14 11.5 14H12.5C12.6326 14 12.7598 13.9473 12.8536 13.8536ZM12.697 9.93769C12.7431 9.89711 12.7726 9.84098 12.78 9.78L13.18 6.56C13.1885 6.48948 13.1819 6.41796 13.1606 6.35019C13.1394 6.28242 13.1039 6.21996 13.0566 6.16698C13.0093 6.11399 12.9512 6.0717 12.8863 6.0429C12.8214 6.01411 12.751 5.99949 12.68 6H11.32C11.249 5.99949 11.1786 6.01411 11.1137 6.0429C11.0488 6.0717 10.9907 6.11399 10.9434 6.16698C10.8961 6.21996 10.8606 6.28242 10.8394 6.35019C10.8181 6.41796 10.8115 6.48948 10.82 6.56L11.22 9.78C11.2274 9.84098 11.2569 9.89711 11.303 9.93769C11.3491 9.97826 11.4086 10.0004 11.47 10H12.53C12.5914 10.0004 12.6509 9.97826 12.697 9.93769Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgMessageFailed = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgMessageFailed;
